<template>
  <div @dragover.prevent="isDrag = true" @dragleave.prevent="isDrag = false" @drop.prevent="onFileDrop($event)">
    <v-file-input
      v-model="file"
      :show-size="1000"
      :accept="accept"
      :label="label"
      :hint="hint"
      :persistent-hint="persistentHint"
      :placeholder="placeholder"
      :persistent-placeholder="persistentPlaceholder"
      :rules="rules"
      :readonly="readonly"
      :filled="isDrag"
      :outlined="outlined"
      :loading="loading"
      small-chips
      @click:clear="handleFileHook(null)"
      ref="fileInput"
    >
      <template #prepend-icon>{{ prependIcon }}</template>
    </v-file-input>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import FileInputMixin from "./FileInputMixin.vue";

@Component({
  components: {}
})
export default class FileInput extends mixins(FileInputMixin) {
  @Prop()
  value!: File;

  @Prop()
  rules!: ((value: any) => string | boolean)[];

  @Prop()
  label!: string;

  @Prop()
  accept!: string;

  @Prop()
  placeholder!: string;

  @Prop()
  readonly!: boolean;

  @Prop()
  hint!: string;

  @Prop({ default: false })
  persistentHint!: boolean;

  @Prop({ default: false })
  persistentPlaceholder!: boolean;

  @Prop({ default: false })
  outlined!: boolean;

  @Prop({ default: true })
  onlyPdf!: boolean;

  @Prop({ default: false })
  loading!: boolean;

  get file() {
    return this.value;
  }

  set file(file: File) {
    this.setFile(file);
  }

  async handleFileHook(file: File) {
    this.$emit("update:value", file);
    this.$emit("input", file);
    this.$emit("change", file);
  }
}
</script>

<style scoped>
.drag {
  animation: appear 0.5s;
  border-radius: 5px;
  background-color: rgba(1, 1, 1, 0.3);
}
@keyframes appear {
  0% {
    background-color: rgba(1, 1, 1, 0);
    border-radius: 0px;
  }
  100% {
    background-color: rgba(1, 1, 1, 0.3);
    border-radius: 5px;
  }
}
</style>
